import React, { useEffect, useState, useContext } from 'react';
import { Checkbox, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { NAME_DEV_SET } from '../../../../function/NameDevSetModel';
import NumericEntry_inputEx from '../../../atoms/Input/NumericEntry_inputEx';
import { AppContext } from '../../../../App';
import { TableBaseStyle } from '../../../../baseStyle/tableBaseStyle';

type DeviceRegistGridBodyProps = {
  item: NAME_DEV_SET;
  seectId: number;
  updateItem: (item: NAME_DEV_SET) => void;
  onClickSettingButton: (indexNo: number) => void;
  selectedID: (indexNo: number) => void;
};

const useStyles = makeStyles(
  createStyles({
    tableItem: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      orderBottomStyle: 'inset',
      borderLeftStyle: 'solid',
      borderRightStyle: 'solid',
      textAlign: 'center',
      height: '8px',
      padding: '1px',
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      minWidth: '80px',
    },
    tableFixC0: {
      width: '80px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      // backgroundColor: 'white',
      position: 'sticky',
      zIndex: 10,
      top: 0,
      left: 0,
    },
    tableFixC1: {
      width: '80px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      // backgroundColor: 'white',
      position: 'sticky',
      zIndex: 10,
      top: 0,
      left: 83,
    },
    tableFixC2: {
      width: '80px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      // backgroundColor: 'white',
      position: 'sticky',
      zIndex: 10,
      top: 0,
      left: 166,
    },
    tableFixC3: {
      width: '150px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      // backgroundColor: 'white',
      position: 'sticky',
      zIndex: 10,
      top: 0,
      left: 249,
    },
    table_no_border_td: {
      borderTop: '0px',
      borderBottom: '0px',
      borderLeft: '0px',
      borderRight: '1px',
      borderRightStyle: 'solid',
      borderRightColor: '#dcdcdc',
      padding: '0px',
      minWidth: '80px',
    },
    colTime: {
      textAlign: 'center',
    },
    //テキスト
    textField: {
      flexGrow: 1,
      height: '100%',
      width: '98%',
      border: 'none',
      backgroundColor: 'transparent',
    },
    buttonStyle: {
      maxWidth: '140px',
      maxHeight: '25px',
      minWidth: '180px',
      minHeight: '25px',
      color: "white",
      backgroundColor: "green"
    },
    selectRow: {
      background: '#7fffd4',
    },
  })
);

const DeviceRegistGridBody: React.FC<DeviceRegistGridBodyProps> = (props: DeviceRegistGridBodyProps) => {
  const classes = useStyles();
  const [est, setEst] = useState<boolean>(props.item.EST != 0);
  const [devNo, setDevNo] = useState<string>(props.item.DEV_NO);
  const [devName, setDevName] = useState<string>(props.item.DEV_NAME);
  const [ratedPower, setRatedPower] = useState<number>(props.item.RATED_POWER);
  const [pole, setPole] = useState<number>(props.item.POLE);
  const [voltage, setVoltage] = useState<number>(props.item.VOLTAGE);
  const [pwrFreq, setPwrFreq] = useState<number>(props.item.PWR_FREQ);
  const [ratedCur, setRatedCur] = useState<number>(props.item.RATED_CUR);
  const [ratedSpeed, setRatedSpeed] = useState<number>(props.item.RATED_SPEED);
  const [excCur, setExcCur] = useState<number>(props.item.EXC_CUR);
  const [startJdgCur, setStartJdgCur] = useState<number>(props.item.startJdgCurPer);
  const [bearingLd, setBearingLd] = useState<string>(props.item.BEARING_LD);
  const [bearingAntiLd, setBearingAntiLd] = useState<string>(props.item.BEARING_ANTI_LD);
  const [invFreq, setInvFreq] = useState<number>(props.item.INV_FREQ);
  const [wealth, setWealth] = useState<number>(props.item.WEALTH);
  const [isCareer, setIsCareer] = useState<boolean>(props.item.CAREER_MASK > 0);
  const [isInvDrv, setIsInvDrv] = useState<boolean>(props.item.INV_DRV_ON > 0);
  const [isEmcType, setIsEmcType] = useState<boolean>(props.item.EMC_TYPE > 0);
  const { login } = useContext(AppContext);
  const { t } = useTranslation();
  const baseClasses = TableBaseStyle();


  //行選択の背景色一時置き
  let lineSelection = '';

  // 行選択ハンドラ
  const selectRow = () => {
    console.debug(['selectRow()', props.item.DEV_INDEX]);
    props.selectedID(props.item.DEV_INDEX);
  };



  return (
    <>
      <div className={`${lineSelection = classes.selectRow} ${lineSelection = baseClasses.bodyRow}`}></div>
      <TableRow
        key={props.item.DEV_INDEX}
        //hover
        onClick={() => {
          selectRow();
        }}
        selected={props.seectId === props.item.DEV_INDEX}
        className={lineSelection}
      >
        <TableCell className={classes.tableItem + ' ' + classes.tableFixC0}>{props.item.DEV_INDEX}</TableCell>
        <TableCell className={classes.tableItem + ' ' + classes.tableFixC1} width={'40px'}>
          <input
            type="checkbox"
            checked={est}
            onChange={(e) => {
              setEst(e.target.checked);
              props.item.EST = e.target.checked ? 1 : 0;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        <TableCell className={classes.tableItem + ' ' + classes.tableFixC2}>
          <input
            type="text"
            maxLength={32}
            className={classes.textField}
            value={devNo}
            onChange={(e) => {
              setDevNo(e.target.value);
              props.item.DEV_NO = e.target.value;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        <TableCell className={classes.tableItem + ' ' + classes.tableFixC3}>
          <input
            type="text"
            maxLength={32}
            className={classes.textField}
            value={devName}
            onChange={(e) => {
              setDevName(e.target.value);
              props.item.DEV_NAME = e.target.value;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* 定格出力(kW) */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={ratedPower}
            minValueLimit={0}
            maxValueLimit={9999999.999}
            fixed={3}
            onChange={(val) => {
              setRatedPower(val);
              props.item.RATED_POWER = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* pole数 */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={pole}
            minValueLimit={0}
            maxValueLimit={99}
            fixed={0}
            onChange={(val) => {
              setPole(val);
              props.item.POLE = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* 電圧(V) */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={voltage}
            minValueLimit={0}
            maxValueLimit={32767}
            fixed={0}
            onChange={(val) => {
              setVoltage(val);
              props.item.VOLTAGE = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* 電源周波数(Hz) */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={pwrFreq}
            minValueLimit={0}
            maxValueLimit={999}
            fixed={0}
            onChange={(val) => {
              setPwrFreq(val);
              props.item.PWR_FREQ = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* 定格電流 */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={ratedCur}
            minValueLimit={0}
            maxValueLimit={9999.999}
            fixed={3}
            onChange={(val) => {
              setRatedCur(val);
              props.item.RATED_CUR = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* 定格回転数(min-1) */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={ratedSpeed}
            minValueLimit={0}
            maxValueLimit={9999}
            onChange={(val) => {
              setRatedSpeed(val);
              props.item.RATED_SPEED = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* 励磁電流(A) */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={excCur}
            minValueLimit={0}
            maxValueLimit={9999.999}
            fixed={3}
            onChange={(val) => {
              setExcCur(val);
              props.item.EXC_CUR = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* 起動判定電流閾値(％) */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={startJdgCur}
            minValueLimit={0}
            maxValueLimit={100}
            onChange={(val) => {
              setStartJdgCur(val);
              props.item.startJdgCurPer = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        <TableCell className={classes.tableItem} width={'100px'}>
          <input
            type="text"
            maxLength={16}
            className={classes.textField}
            value={bearingLd}
            onChange={(e) => {
              setBearingLd(e.target.value);
              props.item.BEARING_LD = e.target.value;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        <TableCell className={classes.tableItem} width={'100px'}>
          <input
            type="text"
            maxLength={16}
            value={bearingAntiLd}
            className={classes.textField}
            onChange={(e) => {
              setBearingAntiLd(e.target.value);
              props.item.BEARING_ANTI_LD = e.target.value;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* インバータ駆動モータ */}
        <TableCell className={classes.tableItem}>
          <input
            type="checkbox"
            checked={isInvDrv}
            onChange={(e) => {
              setIsInvDrv(e.target.checked);
              props.item.INV_DRV_ON = e.target.checked ? 1 : 0;
              if (!e.target.checked) {
                setIsCareer(false);
                props.item.CAREER_MASK = 0;
              }
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* EMC適用 */}
        {login.IsIoT ? null : (
          <TableCell className={classes.tableItem}>
            <input
              type="checkbox"
              checked={isEmcType}
              onChange={(e) => {
                setIsEmcType(e.target.checked);
                props.item.EMC_TYPE = e.target.checked ? 1 : 0;
                props.updateItem(props.item);
              }}
            />
          </TableCell>
        )}

        {/* インバータキャリア周波数(Hz) */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={invFreq}
            minValueLimit={0}
            maxValueLimit={9999.99}
            fixed={2}
            onChange={(val) => {
              setInvFreq(val);
              props.item.INV_FREQ = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* <TableCell className={classes.tableItem}>
        <NumericEntry_inputProps
          className={classes.textField}
          value={revVal}
          onChange={(val) => {
            setRevVal(val);
            props.item.REV_VAL = val;
            props.updateItem(props.item);
          }}
        />
      </TableCell> */}
        {/* 裕度 */}
        <TableCell className={classes.tableItem}>
          <NumericEntry_inputEx
            className={classes.textField}
            value={wealth}
            minValueLimit={0}
            maxValueLimit={99999999}
            onChange={(val) => {
              setWealth(val);
              props.item.WEALTH = val;
              props.updateItem(props.item);
            }}
          />
        </TableCell>
        {/* キャリア周波数マスク */}
        <TableCell className={classes.tableItem}>
          <input
            type="checkbox"
            disabled={!isInvDrv}
            checked={isCareer}
            onChange={(e) => {
              setIsCareer(e.target.checked);
              props.item.CAREER_MASK = e.target.checked ? 1 : 0;
              props.updateItem(props.item);
            }}
          />
        </TableCell>

        {/** レアショートと振動(速度)&振動(変位)の設定*/}
        <TableCell className={classes.tableItem}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            // disabled={!props.buttonEnable}
            disableElevation
            onClick={(e) => {
              //設定画面を開く
              props.onClickSettingButton(props.item.DEV_INDEX);
            }}
          >
            {t('DeviceRegistGridBody.設定', '設定')}
          </Button>
        </TableCell>
      </TableRow>
    </>

  );
};

export default DeviceRegistGridBody;
